import { render, staticRenderFns } from "./FacilityDetails.vue?vue&type=template&id=f6f7546a&scoped=true"
import script from "./FacilityDetails.vue?vue&type=script&lang=js"
export * from "./FacilityDetails.vue?vue&type=script&lang=js"
import style0 from "./FacilityDetails.vue?vue&type=style&index=0&id=f6f7546a&prod&scoped=true&lang=css"
import style1 from "./FacilityDetails.vue?vue&type=style&index=1&id=f6f7546a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f7546a",
  null
  
)

export default component.exports